export const COGNITO_USER_POOL_ID = process.env.REACT_APP_COGNITO_USER_POOL_ID || '';
export const COGNITO_CLIENT_ID = process.env.REACT_APP_COGNITO_CLIENT_ID || '';
export const COGNITO_DOMAIN = (process.env.REACT_APP_COGNITO_DOMAIN || '').replace(/\/$/, '');
export const ACCOUNT_API_ENDPOINT = (process.env.REACT_APP_ACCOUNT_API_ENDPOINT || '').replace(
  /\/$/,
  ''
);

export const AUTH_CALLBACK_PATH = '/auth/callback';
export const AUTH_SIGN_OUT_PATH = '/login';

export const isAuthConfigured = Boolean(COGNITO_USER_POOL_ID && COGNITO_CLIENT_ID);
export const isGoogleLoginConfigured = Boolean(isAuthConfigured && COGNITO_DOMAIN);

export const redirectUri = (): string => `${window.location.origin}${AUTH_CALLBACK_PATH}`;
export const postLogoutUri = (): string => `${window.location.origin}${AUTH_SIGN_OUT_PATH}`;
